import {combineReducers} from 'redux';
import videoSettings, {IVideoSettingsState} from '../modules/video-settings/reducer';
import sessionRouter, {ISessionRouterState} from '../modules/session-router/reducer';
import splitPane, {ISplitPaneState} from '../modules/split-pane/reducer';
import webSocket, {IWebSocketState} from '../modules/web-socket/reducer';
import session, {ISessionState} from '../modules/session/reducer';
import console, {IConsoleState} from '../modules/console/reducer';
import editor, {IEditorState} from '../modules/editor/reducer';
import {videoReducer, IVideoState} from '../modules/video/reducer';

export interface IStore {
    videoSettings: IVideoSettingsState;
    sessionRouter: ISessionRouterState;
    webSocket: IWebSocketState;
    splitPane: ISplitPaneState;
    session: ISessionState;
    console: IConsoleState;
    editor: IEditorState;
    video: IVideoState;
}

export default combineReducers({
    videoSettings,
    sessionRouter,
    webSocket,
    splitPane,
    session,
    console,
    editor,
    video: videoReducer,
});
